import React from 'react'
import { useCallback } from 'react'
import TrackingForm from '../components/Form'

export default function useTrackingForm(salon: Admin.Models.Salon.Stateful) {
    return useCallback((props: Props) => <TrackingForm {...props} salon={salon} />, [])
}

type Props = Omit<Parameters<typeof TrackingForm>[0], "salon">